
export const DEFAULT_URL = 'https://api.doxx.care/api/'
